import '@/helpers/h.dom'
import '@/helpers/h.email-hide'

/**
 * Fckn iOS mobile Safari bug fix
 * also for all others browsers
 */
function calcVH() {
  var vH = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  )
  qs('.wrapper').setAttribute('style', 'min-height:' + vH + 'px')
  console.log(vH)
}
calcVH()
window.addEventListener('onorientationchange', calcVH, true)
window.addEventListener('resize', calcVH, true)

const $videoRef = qs('video')

/*
// get target from media with controls
const $videoRef = document.querySelector('audio[controls], video[controls]');

// assign media player from target (all these options represent the defaults)
const mediaPlayer = function() {
  return new MediaPlayer(
    $videoRef, {
      prefix: 'media',
      lang: {
        play: 'play',
        pause: 'pause',
        mute: 'mute',
        unmute: 'unmute',
        volume: 'volume',
        currentTime: 'current time',
        remainingTime: 'remaining time',
        enterFullscreen: 'enter fullscreen',
        leaveFullscreen: 'leave fullscreen',
        // download: 'download'
      },
      svgs: {
        play: '#symbol-play',
        pause: '#symbol-pause',
        mute: '#symbol-mute',
        unmute: '#symbol-unmute',
        volume: '#symbol-volume',
        currentTime: '#symbol-currentTime',
        remainingTime: '#symbol-remainingTime',
        enterFullscreen: '#symbol-enterFullscreen',
        leaveFullscreen: '#symbol-leaveFullscreen',
        // download: '#symbol-download'
      },
      timeDir: 'ltr',
      volumeDir: 'ltr'
    }
  )
};*/

/**
 * Document Ready
 */
console.time('load')
const readyStateCheckInterval = setInterval(() => {
  if (/loaded|complete/.test(document.readyState)) {
    clearInterval(readyStateCheckInterval)
    document.body.classList.add('is-complete')
    !!$videoRef && document.body.classList.add('is-auth')
    console.timeEnd('load')
  }
}, 10)

/**
 * Hide poster by click
 */
!!$videoRef &&
  qs('.js-poster').on('click', function(e) {
    this.style.display = 'none'
    $videoRef.classList.add('is-played')
    $videoRef.play()
  })

/**
 * Ajax load video
 */
// ajaxVideoLoad($videoRef)
// const ajaxVideoLoad = function(video) {
//   var xhr = new XMLHttpRequest();
//   xhr.open('GET', '1111-11-11-hd.mp4', true);
//   xhr.responseType = 'blob'; //important
//   xhr.onload = function(e) {
//     if (this.status == 200) {
//       console.log("loaded");
//       var blob = this.response;
//       // var video = document.getElementById('id');
//       video.oncanplaythrough = function() {
//         console.log("Can play through video without stopping");
//         URL.revokeObjectURL(this.src);
//       };
//       video.src = URL.createObjectURL(blob);
//       video.load();
//     }
//   };
//   xhr.send();
// }

/**
 * Preload video
 */
// if (!!$videoRef) $videoRef.onprogress = function() {
//   console.log('Downloading video');
// };

// // $videoRef.addEventListener('progress', progressHandler, false);
// const progressHandler = function(e) {
//   if ($videoRef.duration) {
//     var percent = ($videoRef.buffered.end(0) / $videoRef.duration) * 100;
//     console.log(percent);
//     if (percent >= 100) {
//       console.log("loaded!");
//     }
//     $videoRef.currentTime++;
//   }
// }

/*// Preload(qs('#v'), '1111-11-11-hd.mp4', 'video/mp4');
function Preload(element, src, type) {
  function addSourceToVideo(element, src, type) {
    var source = document.createElement('source');
    source.src = src;
    source.type = type;
    element.appendChild(source);
  }

  var video;
  var index = 0;
  window.onload = function() {
    // video = document.getElementsByTagName('video')[0];
    video = $videoRef;
    // addSourceToVideo(video, "http://video-js.zencoder.com/oceans-clip.ogv", "video/ogv");
    addSourceToVideo(video, src, type);
    video.addEventListener("progress", progressHandler, false);
  };

  var progressHandler = function(e) {
    if (video.duration) {
      var percent = (video.buffered.end(0) / video.duration) * 100;
      console.log(percent);
      if (percent >= 100) {
        console.log("loaded!");
      }
      video.currentTime++;
    }
  }
};*/
